const Ls6BronquiolitisAlarma = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'><span className="titulo--lesson--color--2">Bronquiolitis</span> <br /><span className='texto--span'>Otros signos de alarma incluyen </span></h1>

                    <div className="container">
                        <div className='row d-flex pt-4 align-items-center'>
                            <div className='col-1 px-4'>
                                <p className="fw-bold"><ul><li></li></ul></p>
                            </div>
                            <div className='col-10 pt-1'>
                                <p className='texto--parrafo'>Dificultad para respirar, incluyendo sibilancias (un sonido como silbido), respiraci&oacute;n r&aacute;pida, ensanchamiento de las fosas nasales</p>
                            </div>
                        </div>

                        <div className='row d-flex align-items-center'>
                            <div className='col-1 px-4'>
                                <p className="fw-bold"><ul><li></li></ul></p>
                            </div>
                            <div className='col-10 pt-1'>
                                <p className='texto--parrafo'>Decaimiento o somnolencia excesiva</p>
                            </div>
                        </div>

                        <div className='row d-flex align-items-center'>
                            <div className='col-1 px-4'>
                                <p className="fw-bold"><ul><li></li></ul></p>
                            </div>
                            <div className='col-10 pt-1'>
                                <p className='texto--parrafo'>Dificultad con la lactancia o la alimentaci&oacute;n</p>
                            </div>
                        </div>

                        <div className='row d-flex align-items-center'>
                            <div className='col-1 px-4'>
                                <p className="fw-bold"><ul><li></li></ul></p>
                            </div>
                            <div className='col-10 pt-1'>
                                <p className='texto--parrafo'>Labios o u&ntilde;as azulados</p>
                            </div>
                        </div>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls6Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja lh-1 ps-lg-3 ps-xl-5 m-0'>En caso de presentarse cualquiera de estos s&iacute;ntomas, consulte inmediatamente a su m&eacute;dico/a.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>VSR: virus sincitial respiratorio. <br />
                            Adaptado de <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/bronchiolitis/basics/symptoms/con-20019488'>http://www.mayoclinic.org/diseases-conditions/bronchiolitis/basics/symptoms/con-20019488</a></p>
                    </div>

                </div>

                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls6Baby.gif" className='justify-content-start style--image-baby-6' />
                </div>
            </div>
        </div>
    )
}

export default Ls6BronquiolitisAlarma;